// Escapes text before it is placed inside an HTML string (the message screens build markup by hand).
export function escapeHtml (value) {
  return String(value === null || value === undefined ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

// Same, and keeps line breaks of a multi-line message
export function escapeHtmlWithBreaks (value) {
  return escapeHtml(value).replace(/\r?\n/g, '<br>')
}
